import * as React from 'react';

/**
 * @description Хук инициализирует все рефы, нужные для работы в режиме отображения "cloud".
 */
export function useProvideCloudDisplayModeRefs() {
  const wrapperRef = React.useRef(null);
  const moreButtonRef = React.useRef(null);
  const lessButtonRef = React.useRef(null);
  const leftAdornmentRef = React.useRef(null);
  const rightAdornmentRef = React.useRef(null);
  return React.useMemo(() => ({
    wrapperRef,
    moreButtonRef,
    lessButtonRef,
    leftAdornmentRef,
    rightAdornmentRef
  }), []);
}